import { useState } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import GoBackButton from './GoBackButton';

const countries = [
    { name: 'Iraq', code: '+964' },
    { name: 'Jordan', code: '+962' },
    { name: 'Egypt', code: '+20' },
    { name: 'Saudi Arabia', code: '+966' },
    { name: 'UAE', code: '+971' }
];

export default function PhoneVerification({
    onVerificationComplete,
    initialPhone = '',
    isVerified = false,
    businessName,
    salePointName
}) {
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const [phoneNumber, setPhoneNumber] = useState(initialPhone);
    const [phoneSubmitted, setPhoneSubmitted] = useState(isVerified);
    const [otpCode, setOtpCode] = useState(['', '', '', '', '', '']);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleOtpChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;
        const updatedOtp = [...otpCode];
        updatedOtp[index] = value;
        setOtpCode(updatedOtp);

        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`)?.focus();
        }
    };

    const handleContinue = async () => {
        setIsLoading(true);
        setError('');

        try {
            if (!phoneSubmitted) {

                console.log('Inside Phone Not Submitted ====')

                const fullNumber = selectedCountry.code + phoneNumber;
                const phoneObj = parsePhoneNumberFromString(fullNumber);

                if (!phoneObj || !phoneObj.isValid()) {
                    throw new Error("الرجاء إدخال رقم هاتف صحيح");
                }

                const formattedNumber = phoneObj.number;
                try {
                    const res = await fetch(`/api/users/${businessName}/${salePointName}/otp/send`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ phoneNumber: formattedNumber })
                    });

                    if (!res.ok) {
                        const errBody = await res.json().catch(() => null);
                        throw new Error(errBody?.message || 'OTP send failed');
                    }

                    setPhoneNumber(formattedNumber);
                    setPhoneSubmitted(true);
                } catch (err) {
                    console.error('Send OTP error:', err);
                    alert(err.message || 'Failed to send OTP. Please try again.');
                }
            } else {

                console.log('Inside Else ====')

                const code = otpCode.join('');
                if (code.length !== 6) {
                    throw new Error("الرجاء إدخال رمز OTP المكون من 6 أرقام.");
                }

                try {
                    const res = await fetch('/api/users/otp/verify', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ phoneNumber: phoneNumber, otp: code })
                    });

                    if (!res.ok) throw new Error('Invalid OTP');

                    onVerificationComplete(phoneNumber);
                    localStorage.setItem('isVerified', 'true');
                } catch (err) {
                    console.error('OTP verification error:', err);
                    alert('الرمز السري غير صحيح , برجاء التاكد من الرمز');
                }

            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="otp-verification-container">
         
            <h2 className="otp-title">أدخل رقم هاتفك</h2>

            {error && <div className="error-message">{error}</div>}

            {!phoneSubmitted ? (
                <>
                    <div className="phone-input-container">
                        <select
                            value={selectedCountry.code}
                            onChange={(e) => setSelectedCountry(
                                countries.find(c => c.code === e.target.value)
                            )}
                            className="country-select"
                        >
                            {countries.map((country, i) => (
                                <option key={i} value={country.code}>
                                    {country.name} ({country.code})
                                </option>
                            ))}
                        </select>
                        <input
                            type="tel"
                            placeholder="Phone number"
                            value={phoneNumber}
                            onChange={(e) => {
                                const onlyDigits = e.target.value.replace(/\D/g, '');
                                setPhoneNumber(onlyDigits);
                            }}
                            className="phone-input"
                        />
                        
                    </div>
                </>
            ) : (
                <>
                    <p className="otp-instructions">
                      {phoneNumber}  أدخل الرمز المكون من 6 أرقام المرسل إلى 
                    </p>
                    <div className="otp-inputs-container">
                        {otpCode.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp-${index}`}
                                type="text"
                                inputMode="numeric"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                className="otp-input"
                            />
                        ))}
                    </div>
                </>
            )}

            <button
                onClick={handleContinue}
                className="continue-button"
                disabled={
                    isLoading ||
                    (phoneSubmitted && otpCode.join('').length !== 6)
                }
            >
                {isLoading ? 'جاري المعالجة...' : 'استمـر'}
            </button>
             <div style={{ 
              marginTop: '50px',
            }}>
                <GoBackButton />
            </div>
        </div>
    );
}